import { render, staticRenderFns } from "./TMinusWidget.vue?vue&type=template&id=ec7d57e4&scoped=true"
import script from "./TMinusWidget.vue?vue&type=script&lang=js"
export * from "./TMinusWidget.vue?vue&type=script&lang=js"
import style0 from "./TMinusWidget.vue?vue&type=style&index=0&id=ec7d57e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7d57e4",
  null
  
)

export default component.exports